import React from "react";
import { Cell } from "@sonder/ui/source/styled/fragments/Table";
import { SortableCell } from "checkouts/components/SortableCell";
import { InquiryCheckoutSortColumn } from "typings/globalGQLTypes";

export const HeaderRow = () => {
  return (
    <>
      <SortableCell
        firstRow
        rowStart
        sortKey={InquiryCheckoutSortColumn.unit_internal_ref}
      >
        Internal Ref
      </SortableCell>
      <Cell>Guest Name</Cell>
      <SortableCell sortKey={InquiryCheckoutSortColumn.check_out_time}>
        Checkout
      </SortableCell>
      <Cell>Status</Cell>
      <Cell>Platform</Cell>
      <Cell>LCO</Cell>
      <Cell firstRow rowEnd />
    </>
  );
};
